import { SystemText } from 'e4shared';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const Learning = ({ focus, data, profile }) => {
    if (!data?.length) return null;

    const message = SystemText('Home/Widgets/WhatsHappening/Learning', data.length);

    const url = `/develop/learning/${profile.id}`;

    if (focus)
        return <FocusTile tileType="learning" colour="orange" icon="fa-book-open-reader" message={message} url={url} />;

    return null;
};

export default Learning;
